<!-- Navigation -->
<calsoft-vertical-navigation class="bg-cool-gray-900 theme-dark"
                         *ngIf="isScreenSmall"
                         [appearance]="'classic'"
                         [mode]="'over'"
                         [name]="'mainNavigation'"
                         [navigation]="data.navigation.default[0]"
                         [opened]="false">

    <div calsoftVerticalNavigationContentHeader>
        <div class="logo">
               <img [src]="path" onerror="this.src='assets/images/logo/logo.png';" alt="">
        </div>
    </div>

</calsoft-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header">

        <!-- Header container -->
        <div class="container">

            <!-- Top bar -->
            <div class="top-bar">

                <!-- Logo -->
                <div class="logo"
                     *ngIf="!isScreenSmall">
                       <img [src]="path" onerror="this.src='assets/images/logo/logo.png';" alt="">
                </div>

                <!-- Navigation toggle button -->
                <button [attr.guide]="'material-btn-1' + '__' + sanitizeUrl(url)" class="navigation-toggle-button"
                        *ngIf="isScreenSmall"
                        mat-icon-button
                        (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'menu'"></mat-icon>
                </button>

                <!-- Spacer -->
                <div class="spacer"></div>

               
               

             
             

               
              

                <!-- Notifications -->
    

              
                <user></user>

            </div>

            <!-- Bottom bar -->
            <div class="bottom-bar widthcss"
                 *ngIf="!isScreenSmall">
                <calsoft-horizontal-navigation [name]="'mainNavigation'"
                                           [navigation]="data.navigation.horizontal[0]"></calsoft-horizontal-navigation>
            </div>

        </div>

    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

</div>
